import * as React from "react";
import { Box, Grid, Typography, Paper, Button } from "@mui/material";

import News1 from "src/images/home/news1.png";
import axios from "axios";
import { useState } from "react";
import { useEffect } from "react";
import ParseDate from "src/components/parse-date";
import Topbar from "../common/topbar";
import Nav from "../common/nav";
import { Helmet } from "react-helmet-async";

const Item = ({ children }) => {
  return (
    <Paper elevation={1} style={{ boxShadow: "none" }}>
      {children}
    </Paper>
  );
};

const ViewAllNews = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNews = async () => {
    try {
      const response = await axios.get(
        "https://min-api.cryptocompare.com/data/v2/news/",
        {
          params: {
            lang: "EN",
          },
          headers: {
            Authorization:
              "c3b96c7270d82738f2a6e62f491a2bec8eeab7bb94fd6d354595ce1a786d42ee", // Replace with your API Key
          },
        }
      );
      setNews(response.data.Data);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching crypto news:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNews();
    const interval = setInterval(() => {
      fetchNews();
    }, 180000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <p>Loading news...</p>;
  }
  return (
    <>
      <Helmet>
        <meta charset="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Bitstox </title>
        <link
          rel="shortcut icon"
          href="src/images/home/BitstoxFavicon.png"
          type="image/png/ico"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://cdn.jsdelivr.net/npm/remixicon@2.5.0/fonts/remixicon.css"
          rel="stylesheet"
        />
      </Helmet>
      <Box className="homeBody">
        <Box className="homeContainer">
          <Topbar />
          <Nav />
          <Box sx={{ py: 3, display: "block", width: "100%" }}>
            {/* Main Title */}
            <Typography variant="h1" className="mainTitle">
              Latest Crypto News
            </Typography>

            {/* News Section */}
            <Box sx={{ flexGrow: 1 }}>
              <Box
                sx={{
                  marginTop: "1rem",
                  display: "grid",
                  gap: 3,
                  gridTemplateColumns: {
                    xs: "repeat(1, 1fr)",
                    sm: "repeat(2, 1fr)",
                    md: "repeat(3, 1fr)",
                    lg: "repeat(5, 1fr)",
                  },
                }}
              >
                {news?.map((item, index) => (
                  <Item key={index}>
                    <a href="#">
                      <Box sx={{ mt: 2 }}>
                        <Box className="newsImg">
                          <a
                            href={item?.url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            <img
                              style={{ height: "200px" }}
                              src={item?.imageurl}
                              alt="Crypto News"
                            />
                          </a>
                        </Box>
                        {/* <Typography className="newsTag">{item?.title}</Typography> */}
                        <Typography className="newsCaption">
                          {item?.title}
                        </Typography>
                        {/* <Typography className="newsDate">
                          <ParseDate>{item?.publishedAt}</ParseDate>
                        </Typography> */}
                      </Box>
                    </a>
                  </Item>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ViewAllNews;
